import { Component, computed, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, filter, map, startWith } from 'rxjs';
import { last } from 'lodash';
import { SignProvidersService } from '../../../app.services/sign/sign-providers.service';
import { AuthService } from '@libs/app.services/landing/auth.service';
export type RouteType = 'in' | 'up' | 'code';

@Component({
  selector: 'app-sign',
  templateUrl: './sign.component.html',
  styleUrl: './sign.component.scss',
  standalone: false,
})
export class SignComponent implements OnInit {
  startWith = computed<RouteType>(() => (this.route.url.indexOf('up') > -1 ? 'up' : 'in'));
  routes$: Observable<RouteType> = this.route.events.pipe(
    filter(event => event instanceof NavigationEnd),
    map((event: NavigationEnd) => last(event.urlAfterRedirects.split('/'))),
    map((url: string) => url.split('?')),
    map((url: string[]) => url[0] as RouteType),
    startWith(this.startWith()),
  );
  constructor(
    private route: Router,
    private authService: AuthService,
    public providers: SignProvidersService,
  ) {}
  ngOnInit(): void {
    this.authService.hasValidTokenStored && this.route.navigate(['landing']);
  }
}
